import React, { useState, useGlobal } from 'reactn';
import { View, ImageBackground, Text, StyleSheet, Image, TextInput } from 'react-native';
import { ButtonIcon } from '../components/ButtonIcon';
import background from "../assets/img/background.png"
import * as Animatable from 'react-native-animatable';

import Utils from '../lib/Utils';

import ErrorImage from '../assets/img/error.png';

import Colors from '../constants/colors';
import Texts from '../constants/texts';

import { Footer } from "../components/Footer";

const HOOK_URL = "https://hooks.slack.com/services/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";

const ErrorTemplate = ({error}) => {

  const [text, setText] = useState("");
  const [sent, setSent] = useState(false);
  const [user, setUser] = useGlobal("user");

  const sendEmail = () => {
    fetch(HOOK_URL, {
      method: 'post',
      body: JSON.stringify({
        username: `${Utils.capitalize(user.name) + " " + Utils.capitalize(user.last_name)}, from Client: ${Utils.getClientName()}`,
        icon_emoji: ":/",
        text: text + '\n```' + error.stack + '```'
      }),
    });
    setSent(true);
  }

  return (
    <Animatable.View 
      duration={1000}
      animation={"fadeIn"}
      style={styles.container}>
      <ImageBackground source={background} style={styles.container}>
        <View style={styles.errorContainer}>
          <View style={[styles.rowView, { paddingBottom: 50 }]}>
            <Image 
              style={{ height: 150, width: 150, marginRight: 20 }}
              source={ErrorImage} />
              { !sent ? (
                <View style={{ flex: 1 }}>
                  <Text style={styles.errorTitle}>{Texts.error}</Text>
                  <Text style={styles.errorSubtitle}>{Texts.error_help}</Text>
                  <View style={[styles.rowView, { paddingTop: 20 }]}>
                    <TextInput
                      style={styles.userFeedbackText}
                      placeholder={Texts.ask_feedback}
                      placeholderTextColor={Colors.danger_dark_light}
                      multiline={true}
                      numberOfLines={3}
                      onChangeText={(text) => setText(text)}
                      value={text}/>
                    <ButtonIcon inverted name='send' color={Colors.danger_dark} size={40}
                      onPress={sendEmail}/>
                  </View>
                </View>
              ) : (
                <View style={{width: '60vw'}}>
                  <Text style={styles.errorTitle}>{Texts.error_sent_title}</Text>
                  <Text style={styles.errorSubtitle}>{Texts.error_sent}</Text>
                </View>
              )}
          </View>
          <Text style={styles.errorStack}>{error.stack}</Text>
        </View>
      </ImageBackground>
    </Animatable.View>
  )
}

const styles = StyleSheet.create({
  container: {
    height: '100vh',
    width: '100vw',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rowView: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  errorContainer: {
    width: '60%',
  },
  errorTitle: {
    fontSize: 50,
    color: Colors.danger_dark,
  },
  errorSubtitle: {
    width: '80%',
    paddingTop: 7,
    fontSize: 20,
    color: Colors.danger_dark,
  },
  errorStack: {
    borderColor: Colors.white,
    color: Colors.gray,
    borderWidth: 0.5,
    borderRadius: 10,
    backgroundColor: Colors.side_menu_background,
    padding: 30,
    fontSize: 17,
  },
  userFeedbackText: {
    flex: 1,
    //width: '80%',
    padding: 10,
    borderColor: Colors.danger_dark,
    borderWidth: 0.5,
    borderRadius: 10
  }
});

export default ErrorTemplate;
